import { useTranslation } from 'next-i18next';

import MainTitle from '@/molecules/titles/MainTitle';
import { SIZE } from 'types/utils';

const FoilerTile = () => {
  const { t } = useTranslation();

  return (
    <div>
      <MainTitle size={SIZE.SM} showLine>
        {t('how-to-use-foiler')}
      </MainTitle>
      <p className="md-medium text-neutral-800 my-4">
        {t('how-to-use-foiler-text')} <i className="fa-solid fa-sparkles" />
      </p>
      <img alt="" src="/foiler-explanation.png" width={288} />
    </div>
  );
};

export default FoilerTile;
